import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { EthersContext } from "../Context/EthersContext";
import "../Styles/Employee.css";
import Loader from "./Loader";
import { ethers } from "ethers";

function Employee() {
  const { getEmployeeTransactions, getName } = useContext(EthersContext);
  const [Loaded, setLoaded] = useState(false);
  const [Transactions, setTransactions] = useState([]);
  const [Name, setName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    initiator();
  }, []);
  const initiator = async () => {
    setLoaded(false);
    const transactions = await getEmployeeTransactions();
    console.log(transactions);
    if (transactions) setTransactions(transactions);
    const name = await getName();
    if (name === "") navigate("/");
    if (name) setName(name);
    setLoaded(true);
  };
  return (
    <div className="emp_main">
      {Loaded ? (
        <Row>
          {/* Profile Part */}
          {/* <Col sm={12} xs={12} lg={6} md={6}> */}
          <Row>
            <Col sm={12} lg={6} md={12} className="probox">
              {/* <div className="single_advisor_profile wow fadeInUp" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;"> */}
              <div className="pro_box">
                <div class="single_advisor_profile wow ">
                  <div class="advisor_thumb">
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar7.png"
                      alt=""
                    />
                    <div class="social-info">
                      <a href="#">
                        <i class="fa fa-facebook"></i>
                      </a>
                      <a href="#">
                        <i class="fa fa-twitter"></i>
                      </a>
                      <a href="#">
                        <i class="fa fa-linkedin"></i>
                      </a>
                    </div>
                  </div>
                  <div class="single_advisor_details_info">
                    <h6>{Name}</h6>
                    <p class="designation">Employee</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col sm={12} lg={6} md={12} className="pro_box">
              <div className="transactions_main">
                <div className="transactions_head">
                  <h2>Recent transactions</h2>
                </div>
                <div className="transactions_bottom">
                  {Transactions.map((transaction, index) => {
                    let etherValue = ethers.utils.formatEther(
                      transaction.amount
                    );
                    const date = new Date(transaction.time * 1000); // Multiply by 1000 to convert to milliseconds
                    return (
                      <div className="tr_card" key={index}>
                        <div className="tr_amount">{etherValue} avax</div>
                        <div className="trtime">
                          {date.getDate()}/{date.getMonth() + 1}/
                          {date.getFullYear()} {date.getHours()}:
                          {date.getMinutes()}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
          {/* </Col> */}
          {/* Transaction History */}
          {/* <Col sm={12} xs={12} lg={6} md={6}></Col> */}
        </Row>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default Employee;
